const module = { name: 'photos/photoWall/shared', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';

function init() {
    const $container = $('.content-wall');
    $container.imagesLoaded(() => {
        $container.isotope();
        $(window).on('resize', $.debounce(250, () => {
            $container.isotope();
        }));
    });
}
module.exports = {
    init
};
export default module.exports;